import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import _ from "lodash";
import jssVariables from "../../../jss_setup";
import { Field } from "formik";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";
import { commonInputGroupStyles } from "../../forms/inputGroup";

const styles = createUseStyles({
  DriverAge: (props) => ({
    ...commonInputGroupStyles.inputGroup,
    gridTemplateColumns: "1fr",
    gridGap: 0,
    alignItems: "center",
    paddingTop: 0,
    ...(props?.customStyles?.DriverAge ?? {}),
  }),
  label: (props) => ({
    ...commonInputGroupStyles.label,
    ...(props?.customStyles?.label ?? {}),
  }),
  input: (props) => ({
    padding: `calc(${jssVariables.normal_gap} * 1) calc(${jssVariables.normal_gap} / 2)`,
    border: `1px solid ${jssVariables.colors.border}`,
    borderRadius: "5px",
    height: "3rem",
    width: "100%",
    fontSize: "medium",
    textAlign: "center",
    ...(props?.customStyles?.input ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    DriverAge: (props) => ({
      ...(props?.customStyles?.DriverAge ?? {}),
    }),
    input: (props) => ({
      fontSize: "medium",
      ...(props?.customStyles?.input?.smallscreen ?? {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
export const DriverAge = ({ name, id }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const customStyles = cStyler({ type, brand, objName: "carDriverAge" });
  const classes = styles({ customStyles });

  const { t } = useContext(TranslationContext);

  return (
    <div className={classes.DriverAge} id={id}>
      <label className={classes.label}>{t("driverAge")}</label>
      <Field as="input" name={name} className={classes.input} />
    </div>
  );
};
DriverAge.defaultProps = {
  id: "",
};
DriverAge.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
};
